
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IBlock, ISortParameters } from "@/interfaces";
import CryptoCompareService from "@/services/crypto-compare";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["isListed"]),
  },
})
export default class TableBlocksDesktop extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public blocks: IBlock[] | null;
  @Prop({ required: false, default: false }) public hideGeneratedBy: boolean;
  private isListed: boolean;

  get columns() {
    let columns = [
      {
        label: this.$t("COMMON.ID"),
        field: "id",
        thClass: "start-cell",
        tdClass: "start-cell",
      },
      {
        label: this.$t("COMMON.HEIGHT"),
        field: "height",
        type: "number",
        thClass: "text-left hidden md:table-cell",
        tdClass: "text-left hidden md:table-cell wrap-timestamp",
      },
      {
        label: this.$t("COMMON.TIMESTAMP"),
        field: "timestamp.unix",
        type: "number",
        thClass: "text-left hidden md:table-cell",
        tdClass: "text-left hidden md:table-cell wrap-timestamp",
      },
      {
        label: this.$t("COMMON.TRANSACTIONS"),
        field: "transactions",
        type: "number",
      },
      {
        label: this.$t("BLOCK.GENERATED_BY"),
        field: "generator.username",
        thClass: "text-right",
        tdClass: "text-right",
      },
      {
        label: this.$t("BLOCK.TOTAL_FORGED"),
        field: "forged.total",
        type: "number",
        thClass: "end-cell lg:base-cell",
        tdClass: "end-cell lg:base-cell",
      },
      {
        label: this.$t("BLOCK.FEES"),
        field: "forged.fee",
        type: "number",
        thClass: "end-cell hidden lg:table-cell",
        tdClass: "end-cell hidden lg:table-cell",
      },
    ];

    if (this.hideGeneratedBy) {
      columns = columns.filter((column) => column.field !== "generator.username");
    }

    return columns;
  }

  get currencySymbol() {
    return this.$store.getters["currency/symbol"];
  }

  @Watch("blocks")
  public async onBlocksChanged() {
    await this.prepareBlocks();
  }

  @Watch("currencySymbol")
  public async onCurrencySymbolChanged() {
    await this.updatePrices();
  }

  public created() {
    this.prepareBlocks();
  }

  private async prepareBlocks() {
    await this.updatePrices();
  }

  private async fetchPrice(block: IBlock) {
    block.price = await CryptoCompareService.dailyAverage(block.timestamp.unix);
  }

  private async updatePrices() {
    if (!this.blocks) {
      return;
    }

    if (this.isListed) {
      const promises = this.blocks.map(this.fetchPrice);
      await Promise.all(promises);
    }
  }

  private emitSortChange(params: ISortParameters[]) {
    this.$emit("on-sort-change", params[0]);
  }
}
